export default {
    SET_COURSE_RESULT(state, data) {
        state.courseResult = data;
    },
    SET_COURSE_DTL_RESULT(state, data) {
        state.courseDtlResult = data;
    }
}